import React from 'react';
import Overlay from 'react-bootstrap/Overlay';
import ReactTooltip from 'react-bootstrap/Tooltip';


const Tooltip = React.forwardRef(({ text, showTooltip, index, placement="bottom", modifiers = [] }, ref) => {
    // Auto-resolve placement when the preferred side has no room
    let resolvedPlacement = placement;
    if (ref?.current) {
        const rect = ref.current.getBoundingClientRect();
        const pad = 120; // minimum space needed for the tooltip
        if (placement === 'left' && rect.left < pad) {
            resolvedPlacement = rect.right + pad < window.innerWidth ? 'right' : 'top';
        } else if (placement === 'right' && window.innerWidth - rect.right < pad) {
            resolvedPlacement = rect.left > pad ? 'left' : 'top';
        }
    }

    return (
        <Overlay target={ref.current} show={showTooltip} key={index} placement={resolvedPlacement} popperConfig={{ modifiers }}>
            {(props) => (
                <ReactTooltip {...props} style={{ ...props.style, pointerEvents: "none"}}>
                    {text}
                </ReactTooltip>
            )}
        </Overlay>
    );
});


export default Tooltip;
